// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2WwwY","name":"Header_name__1ba9X","birthday":"Header_birthday__2Q13j","skeleton":"Header_skeleton__W2rX2"};